import { ObjectExt } from "./ObjectsExt.js";

export class AudioPlayer {
  constructor() {
    this.onAudioPlayedListeners = [];
    this.initialized = false;
  }

  addEventListener(event, callback) {
    if (event === "onAudioPlayed") {
      this.onAudioPlayedListeners.push(callback);
    }
  }

  async start(workletUrl) {
    this.audioContext = new AudioContext({ sampleRate: 16000 });

    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 512;

    await this.audioContext.audioWorklet.addModule(workletUrl);

    this.workletNode = new AudioWorkletNode(
      this.audioContext,
      "audio-player-processor"
    );

    // Audio graph
    this.workletNode.connect(this.analyser);
    this.analyser.connect(this.audioContext.destination);

    await this.audioContext.resume();

    this.#maybeOverrideInitialBufferLength();
    this.initialized = true;
  }

  playAudio(samples) {
    if (!this.initialized) return;

    // Ensure Float32Array
    const audio =
      samples instanceof Float32Array ? samples : new Float32Array(samples);

    this.workletNode.port.postMessage({
      type: "audio",
      audioData: audio,
    });
  }

  bargeIn() {
    if (!this.initialized) return;

    this.workletNode.port.postMessage({
      type: "barge-in",
    });
  }

  stop() {
    if (ObjectExt.exists(this.workletNode)) {
      this.workletNode.disconnect();
    }
    if (ObjectExt.exists(this.analyser)) {
      this.analyser.disconnect();
    }
    if (ObjectExt.exists(this.audioContext)) {
      this.audioContext.close();
    }

    this.initialized = false;
    this.audioContext = null;
    this.analyser = null;
    this.workletNode = null;
  }

  getSamples() {
    if (!this.initialized) return null;

    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    this.analyser.getByteTimeDomainData(dataArray);
    return [...dataArray].map((e) => e / 128 - 1);
  }

  getVolume() {
    if (!this.initialized) return 0;

    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    this.analyser.getByteTimeDomainData(dataArray);

    let sum = 0;
    for (let i = 0; i < dataArray.length; i++) {
      const v = dataArray[i] / 128 - 1;
      sum += v * v;
    }
    return Math.sqrt(sum / dataArray.length);
  }

  #maybeOverrideInitialBufferLength() {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("audioPlayerInitialBufferLength");
    if (!value) return;

    const bufferLength = parseInt(value, 10);
    if (isNaN(bufferLength)) return;

    this.workletNode.port.postMessage({
      type: "initial-buffer-length",
      bufferLength,
    });
  }
}
